// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1pjiG","label":"CategoryService_label__2AOPA","location":"CategoryService_location__JqEXy"};